import { render, staticRenderFns } from "./SelectOrdersToAdd.vue?vue&type=template&id=ec876f66&scoped=true"
import script from "./SelectOrdersToAdd.vue?vue&type=script&lang=js"
export * from "./SelectOrdersToAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec876f66",
  null
  
)

export default component.exports